module.exports = __webpack_public_path__ + "static/media/01.Karnataka State Award- Bhaskar Kogga Kamath.a0177780.jpg";